import { DataV2API } from "../Endpoints";

class SaveLoadPrices {
    getAll() {
        return DataV2API.get("/saves");
    }

    addTo(savedPrices) {
        return DataV2API.post("/saves", savedPrices);
    }

    loadPrices(save_id) {
        return DataV2API.get("/save/" + save_id);
    }
    delete(save_id) {
        return DataV2API.delete("/save/" + save_id);
    }
}

export default new SaveLoadPrices();
